// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Yip7e","list":"PatternAutocomplete_list__2_Z6M"};